import IncompleteDeliveryReportPanel from '@/modules/order/components/IncompleteDeliveryReportPanel';
import OrderStatus from '@/modules/order/components/OrderStatus';
import OrderDetails from '@/modules/order/pages/OrderDetails';
import SupplierOrderDetailsNav from '@/modules/supplier/pages/OrderDetails/SupplierOrderDetailsNav';

const SupplierOrderDetails = () => {
  return (
    <OrderDetails
      renderNav={SupplierOrderDetailsNav}
      counterparty={{
        label: 'Customer:',
        getName: (order) => order.store?.name || '',
      }}
      renderOrderStatus={(order) => <OrderStatus order={order} isSupplier />}
      renderOrderNotice={({ order, onResolveIncompleteDelivery }) =>
        order.unresolvedIncompleteDelivery ? (
          <IncompleteDeliveryReportPanel
            report={order.unresolvedIncompleteDelivery}
            onResolve={onResolveIncompleteDelivery}
          />
        ) : null
      }
    />
  );
};

export default SupplierOrderDetails;
